import { DateTime } from 'luxon';

import { types } from './common/utils/types';

export interface RoundConfig {
  readonly code: string;
  readonly duration: types;
  readonly contributionDuration?: number;
  readonly name: string;
  readonly tokenPrice: number;
  readonly proxyNFTIds: string[];
  readonly whitelistTokenIds: string[];
  readonly totalAllocation: number;
  readonly maxPurchase: number;
  readonly unlockOnIdoDate: string;
  readonly vesting: string;
}

export interface ApplicationConfig {
  readonly lowBalanceGuide: string;
  readonly updateTime: number;
  readonly idoStart: DateTime;
  readonly rounds: RoundConfig[];
  readonly networkUrl: string;
  readonly metadataUrl: string;
  readonly defaultTokenListUrl: string;
  readonly ergopayUrl: string;
  readonly ergopadUrl: string;
  readonly applicationTick: number;
  readonly kycUrl: string;
  readonly explorerUrl: string;
  readonly spectrumUrl: string;
  readonly support: {
    readonly discord: string;
    readonly telegram: string;
  };
}

export const applicationConfig: ApplicationConfig = {
  applicationTick: 5_000,
  explorerUrl: 'https://explorer.ergoplatform.com',
  kycUrl: 'https://identity.spectrum.fi/v1/',
  ergopayUrl: 'https://ergopay-backend.fly.dev',
  lowBalanceGuide:
    'https://docs.spectrum.fi/docs/user-guides/quick-start#3-get-assets',
  defaultTokenListUrl: 'https://spectrum.fi/ergo-token-list.json',
  spectrumUrl: ' https://api.spectrum.fi/v1/',
  networkUrl: 'https://api.ergoplatform.com',
  metadataUrl:
    'https://raw.githubusercontent.com/spectrum-finance/token-logos/master/logos/ergo',
  ergopadUrl: 'https://api.ergopad.io',
  updateTime: 1_000,
  support: {
    discord: 'https://discord.com/invite/zY2gmTYQVD',
    telegram: 'https://t.me/spectrum_labs_community',
  },
  idoStart: DateTime.utc(2023, 1, 16, 20, 0),
  rounds: [
    {
      code: 'community',
      name: 'Community',
      duration: 360,
      contributionDuration: 192,
      tokenPrice: 0.042,
      totalAllocation: 10714285.71,
      maxPurchase: 10000,
      unlockOnIdoDate: '10%',
      vesting: '6 months',
      whitelistTokenIds: [
        '4d876819dd5517c56c525c5cb9e2428a7affa0741c0464379e6c130a6be730ea',
        '8f97ecb3ce8dca02364cd176b05423e4daace4ec002a9e5952d9913bbfe99e73',
      ],
      proxyNFTIds: [
        '9590feba56ea9e096e875afcc5c0fc7128998ff9986cb5c8302f1be0f1e5fad2', // TODO: change after community round deployed,
        '743e099b14ef0d3caf872a9243ab16a6568d1ff8fadd34a786344e9e21ce32d7', // TODO: change after public round deployed
      ],
    },
    {
      code: 'public',
      name: 'Public',
      duration: 336,
      tokenPrice: 0.05,
      totalAllocation: 10000000,
      maxPurchase: 10000,
      unlockOnIdoDate: '10%',
      vesting: '6 months',
      whitelistTokenIds: [
        '6a66e5c3edd65e2cc2e806c679b98f0959ed9a0556d3605af8cd00051ac0e9fe',
      ],
      proxyNFTIds: [
        '739d8860ad3f7b55dc57a066b1e9e26d7b918dc668f5eaa671f2e789f577c363',
      ],
    },
  ],
};
